import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CareerService } from '../../../services//career.service';
import { MetaService } from '../../../services/meta.service';


@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})
export class CareersComponent implements OnInit {

  imageUrl!: string;
  contentTitle = 'Career Opportunities at XipeTech';
  contentDescription = 'Welcome to XipeTech, We provide the most responsive and functional IT Services. Invest your money in Developing a Brand, not just a website';
  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  records: any[] = [];
  meta: any;
  paginationLinks: any[] = [];

  constructor(private careerService: CareerService, private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {

    const baseUrl = window.location.origin;
    this.loadApiData(1, 12);

    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }

  loadApiData(page: number = 1, per_page: number): void {
    this.careerService.getData(page, per_page).subscribe({
      next: (res) => {
        this.records = res.data;
        this.meta = res.meta;
        this.paginationLinks = res.meta.links;
      },
      error: (err) => console.error('Failed to load blog data:', err)
    });
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}
